window.sl_translate = function sl_translate() {};
window.sl_tr_start = window.sl_translate;
window.sl_tr_end = window.sl_translate;

(function() {
	'use strict';

	var integrationsRegistered = false;
	window.sl_tr_start();
	var slideWarningCopy = "Annie is in beta. She can chat in German, Portuguese, French, Japanese, and Spanish, but slides and videos are currently available in English only.";
	var slideWarningCloseAriaLabel = 'Close slide warning';
	window.sl_tr_end();
	var slideWarning;
	var slideWarningDismissed = false;
	var localizedPathPattern = /^\/(fr|de|ja|pt-br|es)(\/|$)/;

	function isAllowedOrigin(origin) {
		var originUrl;

		try {
			originUrl = new URL(origin);
		} catch (e) {
			return false;
		}

		return originUrl.protocol === 'https:' && (originUrl.hostname === '1mind.com' || originUrl.hostname.endsWith('.1mind.com'));
	}

	function isOneMindEvent(eventName) {
		return typeof eventName === 'string' && eventName.indexOf('1mind_') === 0;
	}

	function isLocalizedSite() {
		return localizedPathPattern.test(window.location.pathname || '');
	}

	function showSlideWarning() {
		var widget = document.getElementById('onemind-widget');
		var slideWarningText;
		var slideWarningClose;

		if (!widget || slideWarningDismissed || !isLocalizedSite()) return;

		if (!slideWarning) {
			slideWarning = document.createElement('div');
			slideWarning.className = 'onemind-slide-warning notranslate';
			slideWarningText = document.createElement('span');
			slideWarningText.className = 'onemind-slide-warning__text';
			slideWarningText.textContent = slideWarningCopy;

			slideWarningClose = document.createElement('button');
			slideWarningClose.className = 'onemind-slide-warning__close';
			slideWarningClose.type = 'button';
			slideWarningClose.setAttribute('aria-label', slideWarningCloseAriaLabel);
			slideWarningClose.textContent = '×';
			slideWarningClose.addEventListener('click', function() {
				slideWarningDismissed = true;
				hideSlideWarning();
			});

			slideWarning.appendChild(slideWarningText);
			slideWarning.appendChild(slideWarningClose);
		}

		if (slideWarning.parentNode !== widget) {
			widget.appendChild(slideWarning);
		}
	}

	function hideSlideWarning() {
		if (slideWarning && slideWarning.parentNode) {
			slideWarning.parentNode.removeChild(slideWarning);
		}
	}

	function syncSlideWarning(eventName) {
		if (!isLocalizedSite()) {
			slideWarningDismissed = false;
			hideSlideWarning();
			return;
		}

		if (eventName === '1mind_slide_expanded') {
			showSlideWarning();
		}

		if (eventName === '1mind_slide_collapsed' || eventName === '1mind_modal_close') {
			slideWarningDismissed = false;
			hideSlideWarning();
		}
	}

	function registerDataLayerListener() {
		var dataLayer = window.dataLayer = window.dataLayer || [];
		var originalPush = dataLayer.push;

		if (dataLayer.__onemindWarningPatched) return;

		dataLayer.push = function() {
			var args = Array.prototype.slice.call(arguments);

			args.forEach(function(entry) {
				if (entry && typeof entry === 'object' && isOneMindEvent(entry.event)) {
					syncSlideWarning(entry.event);
				}
			});

			return originalPush.apply(dataLayer, args);
		};

		dataLayer.__onemindWarningPatched = true;

		dataLayer.forEach(function(entry) {
			if (entry && typeof entry === 'object' && isOneMindEvent(entry.event)) {
				syncSlideWarning(entry.event);
			}
		});
	}

	// ========== ANALYTICS ==========
	function handleAnalyticsEvent(eventName, data) {
		var iframe = document.getElementById('onemind-iframe');
		var iframeSrc = iframe ? (iframe.src || '') : '';
		var isPostForm = iframeSrc.includes('alteryx-post-form');
		var iframeUrl = iframeSrc ? new URL(iframeSrc) : null;
		var displayMode = (iframeUrl && iframeUrl.searchParams.get('display_mode')) || 'embed';

		syncSlideWarning(eventName);

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: eventName,
			source: '1mind',
			ts: data.ts || Date.now(),
			experienceType: isPostForm ? 'postform' : 'preform',
			displayMode: displayMode,
			payload: data.payload || {}
		});
	}

	// ========== SDK INTEGRATIONS ==========
	function registerIntegrations() {
		if (integrationsRegistered) return;
		if (typeof onemind === 'undefined' || !onemind.v1) return;

		// Open links clicked inside the 1Mind widget in a new tab
		onemind.v1.onUrlClicked(function(data) {
			if (data.url) {
				window.open(data.url, '_blank');
			}
		});

		integrationsRegistered = true;
	}

	// ========== MESSAGE LISTENER ==========
	function handleMessage(event) {
		if (!isAllowedOrigin(event.origin)) return;

		var data;
		try {
			data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
			if (data && data.payload && data.payload.state) data = data.payload;
		} catch (e) {
			return;
		}

		if (!data) return;

		// Experience ready → register integrations
		if (data.state === '1mind_sh_experience_ready' || data.state === 'sh_experience_ready') {
			registerIntegrations();
		}

		// Clickstream events (data.type) → analytics
		if (isOneMindEvent(data.type)) {
			handleAnalyticsEvent(data.type, data);
		}

		// Widget state events (data.state) → analytics
		if (isOneMindEvent(data.state)) {
			handleAnalyticsEvent(data.state, data);
		}

	}

	registerDataLayerListener();
	window.addEventListener('message', handleMessage);
})();
